import React, { useEffect, useState } from "react";
import { TID } from "@/lib/testIds";
import { Sparkles, Loader2 } from "lucide-react";

function Skel({ className = "" }) {
  return <div className={`bg-zinc-800/60 animate-pulse rounded-md ${className}`} />;
}

const STAGES = [
  { at: 0, text: "抓取即時股價與財務資料…" },
  { at: 4, text: "整理過去 4 季實際數據 + AI 推估未來 4 季…" },
  { at: 10, text: "Claude Sonnet 4.5 正在深度分析優勢、風險、競爭對手…" },
  { at: 25, text: "首次分析約需 30-50 秒，之後 24 小時內快取，僅需 1 秒" },
];

export default function LoadingSkeleton() {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setElapsed((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, []);
  const currentStage = STAGES.filter((s) => s.at <= elapsed).slice(-1)[0] || STAGES[0];

  return (
    <div className="space-y-4" data-testid={TID.loadingSkeleton}>
      <div
        className="card-tactical p-4 flex items-center gap-3 border-blue-500/20 bg-blue-500/[0.03]"
        data-testid="loading-progress-banner"
      >
        <div className="relative">
          <Loader2 className="w-5 h-5 text-blue-400 animate-spin" strokeWidth={1.8} />
          <Sparkles className="w-3 h-3 text-cyan-300 absolute -top-1 -right-1" strokeWidth={2} />
        </div>
        <div className="flex-1">
          <div className="text-xs sm:text-sm text-white font-medium">
            {currentStage.text}
          </div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono mt-0.5">
            elapsed · {elapsed}s
          </div>
        </div>
      </div>

      <div className="card-tactical p-6">
        <div className="flex items-center gap-3">
          <Skel className="w-16 h-4" />
          <Skel className="w-24 h-4" />
        </div>
        <div className="mt-4 flex items-baseline gap-3">
          <Skel className="w-48 h-8" />
          <Skel className="w-16 h-4" />
        </div>
        <Skel className="mt-3 w-full max-w-2xl h-3" />
        <Skel className="mt-1 w-full max-w-xl h-3" />
        <div className="mt-6 grid grid-cols-2 md:grid-cols-6 gap-3">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="card-tactical p-4">
              <Skel className="w-16 h-3" />
              <Skel className="mt-2 w-20 h-6" />
            </div>
          ))}
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
        <div className="lg:col-span-8 card-tactical p-4 h-64" />
        <div className="lg:col-span-4 card-tactical p-4 h-64" />
        <div className="lg:col-span-6 card-tactical p-4 h-56" />
        <div className="lg:col-span-6 card-tactical p-4 h-56" />
      </div>
    </div>
  );
}
